
export const SZ_CLAIM_PAGE_INDICES = {
    CLAIMENT_DETAILS: 0,
    DECEASED_DETAILS: 1,
    UPLOAD_DOCUMENTS: 2,
    SUCCESS_PAGE: 3
};

export const PAGES = [
    {
        URL:'/sizotsa-funeral-claim/claiment-details/',
        TITLE:'Claiment Details'
},
    {
        URL:'/sizotsa-funeral-claim/deceased-details/',
        TITLE:'Deceased Details'
},
    {
        URL:'/sizotsa-funeral-claim/upload-documents/',
        TITLE:'Upload Documents'
},
    {
        URL:'/sizotsa-funeral-claim/successful/',
        TITLE:'Success Page'
},
]

export const PROGRESS_BAR_STEPS=[
    {
    title:"Claiment Details",
    isActive:false,
    isCompleted: false,
    },
    {
    title:"Deceased Details",
    isActive:false,
    isCompleted:false,
    },
    {
    title:"Upload Documents",
    isActive:false,
    isCompleted:false,
    },
]